import { z } from "zod";

import { BaseForm, FormInput, FormToggle } from "components/BaseForm";
import { useAccountMutations } from "hooks/useAccountsTable";

const makeSchema = originalApiKey =>
  z
    .object({
      email_address: z.string().min(1, "Email Address is required"),
      active: z.boolean(),
      api_key: z.string().min(1, "API Key is required"),
      secret: z.string().optional(),
    })
    .superRefine((data, ctx) => {
      const keyChanged = !originalApiKey || data.api_key !== originalApiKey;
      if (keyChanged && !data.secret) {
        ctx.addIssue({
          path: ["secret"],
          code: z.ZodIssueCode.custom,
          message: "Secret is required when the API Key changes",
        });
      }
    });

const AccountForm = ({ model, onSuccess, onCancel }) => {
  const { create, update } = useAccountMutations();
  const isEdit = !!model?.id;

  const handleSubmit = async values => {
    if (isEdit) {
      await update.mutateAsync({ id: model.id, data: values });
    } else {
      await create.mutateAsync(values);
    }
  };

  return (
    <BaseForm
      schema={makeSchema(model?.api_key)}
      defaultValues={{
        email_address: model?.email_address || "",
        active: !!model?.active,
        api_key: model?.api_key || "",
        secret: "",
      }}
      onSubmit={handleSubmit}
      onSuccess={onSuccess}
      onCancel={onCancel}
      submitButtonText={isEdit ? "Save" : "Create"}
    >
      <FormInput name="email_address" label="Email Address" required />
      <FormInput name="api_key" label="API Key" required />
      <FormInput
        name="secret"
        label="Secret"
        type="password"
        required={!isEdit}
        placeholder={isEdit ? "Leave blank if API Key is unchanged" : undefined}
      />
      <FormToggle name="active" label="Active" />
    </BaseForm>
  );
};

export default AccountForm;
